import React from "react"
import styles from './Button.module.scss';

export const Button: React.FC = () => {
  return (
    <button
      type="submit"
      id="submit-button"
      className={styles.Button}
    >
      Enviar
    </button>
  )
}